import { render } from "./ProductList.vue?vue&type=template&id=45418c41&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=45418c41&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45418c41"]])

export default __exports__